import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { useState, useRef } from 'react';

const reviews = [
  {
    name: 'עומר',
    text: 'עשיתי בדיקת מנוף בתוך המרפאה הכל היה מסודר ומהיר הצוות קיבל אותי בזמן עשו לי את כל הבדיקות בלי סיבוכים בדיקת שמיעה ראייה ולחץ דם השירות היה נעים ואכפתי באמת תודה רבה לכם',
    rating: 4.5
  },
  {
    name: 'טהא',
    text: 'עשיתי בדיקות לקרדיולוגיה כולל אק"ג ואקו לב השירות היה ברמה גבוהה מאוד הרופא הסביר לי הכל בלי למהר ועם הרבה סבלנות ממש מרגישים שחשוב להם',
    rating: 5
  },
  {
    name: 'ג׳ריס',
    text: 'באתי לבדיקה לרישיון מנופאי עשו לי בדיקת שמיעה בדיקת ראייה לחץ דם הכל היה במקום אחד בלי לרוץ בין קליניקות באמת שירות נוח ומסודר ממליץ',
    rating: 4
  },
  {
    name: 'איריס',
    text: 'סבא שלי קיבל מכשיר שמיעה דרך המרכז הרפואי הצוות היה מדהים התאימו לו בדיוק לפי הצורך שלו והסבירו כל דבר בצורה פשוטה ובלי לחץ ממליצה מכל הלב',
    rating: 5
  },
  {
    name: 'אחמד',
    text: 'אני עובד במפעל עם חשיפה לרעש והגעתי לבדיקה תעסוקתית בדקו לי שמיעה לחץ דם וכל הבדיקות הדרושות הצוות היה מקצועי מאוד והבדיקות עברו מהר ובצורה מכובדת',
    rating: 4.5
  },
  {
    name: 'רועי ',
    text: 'עשיתי בדיקה תעסוקתית בגלל חשיפה לרעש במפעל הגיעו עד אלינו עם צוות רפואי מצויד הכל היה מסודר ואחראי ממש חוויה חיובית שלא רואים כל יום',
    rating: 4
  },
  {
    name: 'שחר',
    text: 'הגעתי עם כאבי אוזניים חמורים והרופא טיפל בי בסבלנות ובמקצועיות משהו שלא רואים בכל מקום ממליצה מאוד באמת אנשים מדהימים',
    rating: 5
  },
  {
    name: 'סמיר',
    text: 'פעם ראשונה שאני מגיע וכל מה שאני יכול להגיד זה תודה שירות מעולה מקום נקי הרופאה של העיניים הייתה סופר נחמדה וקשובה',
    rating: 5
  },
  {
    name: 'נטע',
    text: 'הייתי בבדיקה שגרתית אצל הגניקולוגית ד״ר סוהא והיה פשוט מושלם אין לחץ הם לוקחים את הזמן ועובדים באווירה רגועה ונעימה',
    rating: 4.5
  },
  {
    name: 'אחמד',
    text: 'באמת מרכז ברמה גבוהה הכל מסודר הנציגים בקבלה מדהימים וגם פרמדיקים עם הרבה ניסיון ממליץ לכל מי שמחפש מקום טוב בצפון',
    rating: 5
  },
];

const desktopSliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  rtl: false,
  appendDots: (dots: any) => (
    <div style={{ marginTop: '2.5rem' }}>
      <ul style={{ margin: '0px' }}> {dots} </ul>
    </div>
  ),
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 640, settings: { slidesToShow: 1 } }
  ]
};

const mobileSliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  rtl: false,
  appendDots: (dots: any) => (
    <div style={{ marginTop: '2.5rem' }}>
      <ul style={{ margin: '0px' }}> {dots} </ul>
    </div>
  ),
};

const FullStar = () => (
  <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" /></svg>
);
const HalfStar = () => (
  <svg className="w-6 h-6 text-yellow-500" viewBox="0 0 20 20">
    <defs>
      <linearGradient id="half">
        <stop offset="50%" stopColor="currentColor"/>
        <stop offset="50%" stopColor="white" stopOpacity="1"/>
      </linearGradient>
    </defs>
    <path fill="url(#half)" stroke="currentColor" strokeWidth="0.5" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
  </svg>
);
const EmptyStar = () => (
  <svg className="w-6 h-6 text-yellow-300" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" /></svg>
);

const ReviewCard = ({ review, t }: { review: { name: string; text: string; rating: number | null }, t: any }) => {
  const [expanded, setExpanded] = useState(false);
  const maxLength = 180;
  const isLong = review.text.length > maxLength;
  const displayText = expanded || !isLong ? review.text : review.text.slice(0, maxLength) + '...';
  return (
    <div className="px-2 h-full flex items-stretch">
      <div className="bg-white rounded-xl shadow p-6 flex flex-col justify-between h-full min-h-[320px] max-h-[320px]">
        {/* Stars */}
        {typeof review.rating === 'number' && (
          <div className="flex justify-center mb-2">
            {Array.from({ length: 5 }).map((_, i) => {
              const rating = review.rating ?? 0;
              if (rating >= i + 1) return <FullStar key={i} />;
              if (rating >= i + 0.5) return <HalfStar key={i} />;
              return <EmptyStar key={i} />;
            })}
          </div>
        )}
        {/* Review Text */}
        <div className="flex-1 flex flex-col items-center justify-center text-center text-gray-700 mb-4">
          <span>{displayText}</span>
          {isLong && (
            <button
              className="text-primary-dark underline mt-2 text-sm"
              onClick={() => setExpanded(e => !e)}
            >
              {expanded ? t('reviews.showLess', 'Show less') : t('reviews.readMore', 'Read more')}
            </button>
          )}
        </div>
        {/* Name */}
        <div className="font-bold text-center mt-4 text-primary-dark">
          {review.name}
        </div>
      </div>
    </div>
  );
};

const ReviewsSection = () => {
  const { t } = useTranslation();
  const sliderRef = useRef<any>(null);
  return (
    <section id="reviews" className="pt-24 pb-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-8 text-center">
          {t('reviews.title')}
        </h2>
        <div className="max-w-4xl mx-auto relative flex items-center">
          {/* Left arrow - only if more than 3 reviews */}
          {reviews.length > 3 && (
            <button
              onClick={() => sliderRef.current?.slickPrev()}
              className="bg-white bg-opacity-80 p-3 rounded-full shadow-lg z-10 hover:bg-opacity-100 transition-all flex-shrink-0 hidden md:block absolute left-0 top-1/2 -translate-y-1/2"
              style={{ left: '-56px' }}
              aria-label="Previous"
            >
              &#8592;
            </button>
          )}
          <div className="relative w-full">
            <Slider ref={sliderRef} {...desktopSliderSettings}>
              {reviews.map((review, idx) => (
                <ReviewCard key={idx} review={review} t={t} />
              ))}
            </Slider>
          </div>
          {/* Right arrow - only if more than 3 reviews */}
          {reviews.length > 3 && (
            <button
              onClick={() => sliderRef.current?.slickNext()}
              className="bg-white bg-opacity-80 p-3 rounded-full shadow-lg z-10 hover:bg-opacity-100 transition-all flex-shrink-0 hidden md:block absolute right-0 top-1/2 -translate-y-1/2"
              style={{ right: '-56px' }}
              aria-label="Next"
            >
              &#8594;
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection; 